<template>
  <li
    v-if="checkPermission(item.permission)"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
      :class="isRoyalTenant ? 'royal-navigation-link' : ''"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { mapGetters } from 'vuex'
import { tenant } from '@/constants/config'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tenant,
    }
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },
  computed: {
    ...mapGetters(['permissions', 'permissionObjects']),
    isRoyalTenant() {
      return this.tenant === 'royalexpress'
    },
  },
  methods: {
    // Check if any of the route permissions exist and are active
    checkPermission(routePermissions) {
      if (!routePermissions) return true
      if (!this.permissions) return true

      // Check if this is a webhook-related permission
      const webhookPermissions = ['view-webhook', 'show-webhook', 'create-webhook', 'edit-webhook', 'view-webhook-logs', 'show-webhook-logs']
      const isWebhookPermission = routePermissions.some(perm => webhookPermissions.includes(perm))

      if (isWebhookPermission) {
        // For webhook permissions, check both existence and is_active === 1
        if (this.permissionObjects && this.permissionObjects.length > 0) {
          return routePermissions.some(permissionName => {
            const permission = this.permissionObjects.find(p => p.name === permissionName)
            return permission && permission.is_active === 1
          })
        }
        // Fallback to regular permission check if permissionObjects not loaded yet
        return this.permissions.some(i => routePermissions.includes(i))
      }

      // For non-webhook permissions, use the existing logic
      return this.permissions.some(i => routePermissions.includes(i))
    },
  },
}
</script>
